var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" Password expires on: ")]),_c('div',{class:[_vm.$style.passwordExpirationDate, _vm.dateColor]},[_vm._v(" "+_vm._s(_vm.dateLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }